var React = require('react');

function Pinned (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"9.723 9.428 8.102 7.858 8.102 1.572 8.912 1.572 8.912 0 0.81 0 0.81 1.572 1.62 1.572 1.62 7.858 0 9.428 0 11 3.861 11 3.861 14 5.861 14 5.861 11 9.723 11 9.723 9.428","fill":"currentColor"}));
}

Pinned.defaultProps = {"viewBox":"0 0 9.72306 13.99985"};

module.exports = Pinned;

Pinned.default = Pinned;
